<div *ngIf="loading" class="loader">
  <div class="spinner-border" role="status"></div>
</div>

<main
  class="detail-page"
  *ngIf="showAuthorization && authorization && !loading"
>
  <div class="detail-page__container">
    <h1 class="detail-page__title">{{ 'esDetail' | i18next }}</h1>

    <section class="detail-card">
      <h5 class="detail-card__title">{{ 'generalData' | i18next }}</h5>

      <div class="projectData">
        <div class="rowInfo">
          <p class="label">{{ 'centerExit' | i18next }}</p>
          <p class="text">
            {{ authorization.originCenterId || 'noData' | i18next }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'centerEntry' | i18next }}</p>
          <p class="text">
            {{ authorization.destinationCenterId || 'noData' | i18next }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'reason' | i18next }}</p>
          <p class="text">
            {{ getTranslatedReason(authorization.reason) }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'exitDate' | i18next }}</p>
          <p class="text">
            {{
              authorization.checkOutDate
                ? (authorization.checkOutDate | date: 'dd/MM/yyyy HH:mm')
                : ('noData' | i18next)
            }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'entryDate' | i18next }}</p>
          <p class="text">
            {{
              authorization.checkInDate
                ? (authorization.checkInDate | date: 'dd/MM/yyyy HH:mm')
                : ('noData' | i18next)
            }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'reasonText' | i18next }}</p>
          <p class="text">
            {{ authorization.reasonObservations || 'noData' | i18next }}
          </p>
        </div>
      </div>
    </section>

    <section class="detail-card">
      <h5 class="detail-card__title">{{ 'authorizer' | i18next }}</h5>

      <div class="projectData">
        <div class="rowInfo">
          <p class="label">{{ 'nis' | i18next }}</p>
          <p class="text">
            {{ authorization.authorizer?.id || 'noData' | i18next }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'name' | i18next }}</p>
          <p class="text">
            {{ authorization.authorizer?.fullName || 'noData' | i18next }}
          </p>
        </div>
      </div>
    </section>

    <section class="detail-card">
      <h5 class="detail-card__title">{{ 'driverData' | i18next }}</h5>

      <div class="projectData">
        <div class="rowInfo">
          <p class="label">{{ 'name' | i18next }}</p>
          <p class="text">
            {{ authorization.driver?.fullName || 'noData' | i18next }}
          </p>
        </div>

        <div class="rowInfo" *ngIf="authorization.driver?.internalDriverId">
          <p class="label">{{ 'nis' | i18next }}</p>
          <p class="text">
            {{ authorization.driver?.internalDriverId }}
          </p>
        </div>

        <div class="rowInfo" *ngIf="authorization.driver?.externalDriverId">
          <p class="label">{{ 'nif' | i18next }}</p>
          <p class="text">
            {{ authorization.driver?.externalDriverId }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'driverLicense' | i18next }}</p>
          <p class="text">
            {{ authorization.driver?.driverLicense ? 'Si' : 'No' }}
          </p>
        </div>
      </div>
    </section>

    <section class="detail-card" *ngIf="authorization.stockVehicle">
      <h5 class="detail-card__title">{{ 'bookVehicleDataTitle' | i18next }}</h5>

      <div class="projectData">
        <div class="rowInfo">
          <p class="label">{{ 'vinNumber' | i18next }}</p>
          <p class="text">
            {{
              authorization.stockVehicle?.vehicles?.[0]?.vin || 'noData'
                | i18next
            }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'model' | i18next }}</p>
          <p class="text">
            {{
              authorization.stockVehicle?.vehicles?.[0]?.model || 'noData'
                | i18next
            }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'color' | i18next }}</p>
          <p class="text">
            {{
              authorization.stockVehicle?.vehicles?.[0]
                ?.exteriorColorDescription || 'noData' | i18next
            }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'plateNumber' | i18next }}</p>
          <p class="text">
            {{
              authorization.stockVehicle?.vehicles?.[0]?.plateNumber || 'noData'
                | i18next
            }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'redPlate' | i18next }}</p>
          <p class="text">
            {{ authorization.stockVehicle?.redPlate || 'noData' | i18next }}
          </p>
        </div>

        <div class="rowInfo">
          <p class="label">{{ 'truckPlateNumber' | i18next }}</p>
          <p class="text">
            {{
              authorization.stockVehicle?.truckPlateNumber || 'noData' | i18next
            }}
          </p>
        </div>
      </div>
    </section>

    <section class="detail-card" *ngIf="authorization.observations">
      <h5 class="detail-card__title">{{ 'observations' | i18next }}</h5>

      <div class="projectData">
        <div class="rowInfo">
          <p class="label">{{ 'observations' | i18next }}</p>
          <p class="text">
            {{ authorization.observations }}
          </p>
        </div>
      </div>
    </section>
  </div>
</main>

<div *ngIf="!showAuthorization && !loading" class="error-container">
  <div class="detail-page__container">
    <div class="detail-card detail-card--error">
      <p class="text-muted mb-0">{{ 'errorDetail' | i18next }}</p>
    </div>
  </div>
</div>
